import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { WorkbenchMetricsResponse, WorkbenchDataResponse } from '@/types/api';

export function useWorkbenchMetrics() {
  return useQuery({
    queryKey: ['workbench', 'metrics'],
    queryFn: async () => {
      const res = await apiClient.get<WorkbenchMetricsResponse>('/workbench/metrics');
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
  });
}

export interface WorkbenchDataParams {
  start_date: string;
  end_date: string;
  y1_metrics: string[];
  y2_metrics: string[];
  agg_level: string;
}

export function useWorkbenchData(params: WorkbenchDataParams) {
  return useQuery({
    queryKey: ['workbench', 'data', params],
    queryFn: async () => {
      const res = await apiClient.get<WorkbenchDataResponse>('/workbench/data', {
        params: {
          start_date: params.start_date,
          end_date: params.end_date,
          y1_metrics: params.y1_metrics.join(','),
          y2_metrics: params.y2_metrics.join(','),
          agg_level: params.agg_level,
        },
      });
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    enabled:
      !!params.start_date &&
      !!params.end_date &&
      (params.y1_metrics.length + params.y2_metrics.length) > 0,
  });
}
